import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { createLookalikeAudience } from 'scenes/CustomAudiences/LookalikeAudiences/sources/lookalikeAudiences';

import { remove } from '../queryKeyFactory';
import { createBatchAction } from './createBatchAction';

export const useBatchCreateLookalikeAudience = () => {
  const { showErrorMessage } = useScreenMessage();

  const createMutation = useMutation(
    remove(),
    createBatchAction(createLookalikeAudience),
    {
      successMessage: ({ results }) =>
        `${results?.length} Lookalike Audiences added`,
      errorMessage: false,
      onError: ({ errors, total }) => {
        showErrorMessage(errors, {
          multiple: true,
          multipleTitle: `Unable to add ${errors.length} of ${total} Lookalike audiences`,
        });
      },
    }
  );

  return [createMutation.mutateAsync, createMutation];
};
